<template>
  <div class="altura-componente-container pa-5">
    <span id="nomeEmpresaToolbar">{{ nomeEmpresa }}</span>
    <v-container fluid grid-list-xl white>
      <v-row>
        <v-col cols="12" xl="2" md="3" sm="12" xs="12">
          <foto-empresa class="margin-element"/>
        </v-col>
        <v-col cols="12" xl="2" md="3" sm="12" xs="12">
          <pacientes-agendados-periodo class="margin-element"/>
        </v-col>
        <v-col cols="12" xl="2" md="3" sm="12" xs="12">
          <pacientes-em-atendimento :pacientesEmAtendimento="pacientesEmAtendimento" class="margin-element"/>
        </v-col>
        <v-col cols="12" xl="2" md="3" sm="12" xs="12">
          <resumo-pacientes-cadastrados :resumo="resumoCadastrosPacientes" class="margin-element"/>
        </v-col>
        <v-col cols="12" xl="2" md="3" sm="12" xs="12">
          <resumo-pacientes-ortodontia :resumo="resumoCadastrosPacientes"/>
        </v-col>
      </v-row>
    </v-container>
    <sala-espera class="mt-4"/>
  </div>
</template>


<script>
import SalaEspera from '@/views/pages/salaEspera/SalaEspera.vue'
import FotoEmpresa from '@/views/pages/inicio/FotoEmpresa.vue'
import PacientesAgendadosPeriodo from '@/views/pages/inicio/PacientesAgendadosPeriodo.vue'
import PacientesEmAtendimento from '@/views/pages/inicio/PacientesEmAtendimento.vue'
import {actionTypes} from '@/core/constants'
import ResumoPacientesCadastrados from '@/views/pages/inicio/ResumoPacientesCadastrados.vue'
import ResumoPacientesOrtodontia from '@/views/pages/inicio/ResumoPacientesOrtodontia.vue'

export default {
    name: 'Inicio',
    components: {
        ResumoPacientesOrtodontia,
        ResumoPacientesCadastrados, PacientesEmAtendimento, PacientesAgendadosPeriodo, FotoEmpresa, SalaEspera
    },
    data() {
        return {
            pacientesEmAtendimento: [],
            resumoCadastrosPacientes: null,
        }
    },
    computed: {
        nomeEmpresa: function () {
            if (this.$store.state.comum.usuarioLogado.empresa) {
                return this.$store.state.comum.usuarioLogado.empresa.nome
            }
            return 'Dashboard'
        },
    },
    async mounted() {
        await this.buscarDashboard()
    },
    methods: {
        async buscarDashboard() {
            this.setMensagemLoading('Buscando dashboard...')
            const resposta = await this.$store.dispatch(actionTypes.INICIO.DASHBOARD)
            if (resposta) {
                this.pacientesEmAtendimento = resposta.pacientesEmAtendimento
                this.resumoCadastrosPacientes = resposta.resumoCadastrosPacientes
            }
        }
    }

}
</script>


<style scoped lang="stylus">

#nomeEmpresaToolbar
  font-size 18px
  font-weight bold
  color var(--theme-primary)

.header-element-inicio
  display flex
  flex-direction row

.margin-elementT
  margin-right 20px


@media (max-width 720px)
  .header-element-inicio
    flex-direction column

  .margin-elementT
    margin 0
    margin-bottom 20px

</style>
